exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#SidebarIcon{background-color:rgba(255,255,255,0.95);height:calc(100vh - 56px)}#SidebarIcon .icon{height:60px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;border-bottom:1px solid #757575;border-bottom:1px solid #e0e0d7}#SidebarIcon .icon:hover{cursor:pointer}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/Sidebar/components/SidebarIcon/style.scss
// module id = 1184
// module chunks = 0